import { useState, useRef } from "react";

export const useLineChart = (title, titleY) => {
    const chartRef = useRef(null);

    const [options, setOptions] = useState({
        chart: {
            zoomType: "xy",
            events: {
                load: function () {
                    chartRef.current = this;
                },
            },
        },
        title: {
            text: title,
            align: "left",
        },
        lang: {
            viewFullscreen: "Ver en pantalla completa",
            loading: "Cargando...",
            noData: "No hay datos para mostrar",
        },
        exporting: {
            buttons: {
                contextButton: {
                    menuItems: ["viewFullscreen"],
                },
            },
        },
        yAxis: {
            min: 1,
            title: {
                text: titleY,
            },
        },
        legend: {
            enabled: false,
        },
        xAxis: {
            min: 1,
            accessibility: {
                rangeDescription: "Range: 2010 to 2020",
            },
        },
        plotOptions: {
            series: {
                label: {
                    connectorAllowed: false,
                },
            },
        },
        series: [],
        responsive: {
            rules: [
                {
                    condition: {
                        maxWidth: 500,
                    },
                    chartOptions: {
                        legend: {
                            layout: "horizontal",
                            align: "center",
                            verticalAlign: "bottom",
                        },
                    },
                },
            ],
        },
        credits: { enabled: false },
    });

    const showLoading = () => chartRef.current?.showLoading();
    const hideLoading = () => chartRef.current?.hideLoading();

    const onChartReady = (chartInstance) => {
        chartRef.current = chartInstance;
    };

    return {
        options,
        setOptions,
        showLoading,
        hideLoading,
        onChartReady,
    };
};
